import * as d3 from 'd3'

import {
  HEATMAP_COLORS,
  OPACITY_HEATMAP,
  OPACITY_PHEATMAP
} from '@aytm/app/stats/page/question-views/sh/components/shelf/lib/heatmapColors'

export const renderContours = (svgSelection, { heatmap, mode }) => {
  const { contours, levels } = heatmap

  if (!contours?.length || !levels) return

  const opacityValues = mode === 'heatmap' ? OPACITY_HEATMAP : OPACITY_PHEATMAP

  const getOpacity = d3.scaleLinear().domain([0, levels.length]).range(opacityValues)
  const getColor = d3
    .scaleLinear()
    .domain([0, levels.length - 1])
    .range(HEATMAP_COLORS)

  const line = d3
    .line()
    .x(d => d.x)
    .y(d => d.y)

  contours.forEach(item => {
    // (2) Dead dedup — `indexOf` on fresh object refs always returns -1.
    const points = item.contour.reduce((arr, point) => {
      const newItem = { x: point.x, y: point.y }
      // eslint-disable-next-line unicorn/prefer-includes
      if (arr.indexOf(newItem) === -1) arr.push(newItem)
      return arr
    }, [])

    svgSelection
      .append('path')
      .attr('d', line(points))
      .attr('fill', getColor(levels.indexOf(item.level)))
      .attr('fill-opacity', getOpacity(levels.indexOf(item.level)))
  })
}
